<template>
  <div class="container-fluid">
    <div class="row">
      <!-- List of medias -->
      <div class="col-12 col-lg-8 col-xl-9">
        <div class="container-fluid">
          <!-- Top Info Label -->
          <div class="row">
            <div class="col-12 no-padding-sides">
              <v-alert type="info" style="margin-bottom: 0" dense text>
                Cette base de média sert de bibliothèque. Les médias peuvent ensuite être rattachés lors de la création et lors de l'édition d'un exercice.
              </v-alert>
            </div>
          </div>
          <!-- Medias -->
          <div class="row">
            <div class="col-12 no-padding-sides">
              <h5
                v-if="(!images || !images.length) && (!videos || !videos.length) && (!urls || !urls.length) && (!others || !others.length)"
                class="text-center"
                style="font-style: italic"
              >
                Ajoutez des médias pour remplir votre bibliothèque.
              </h5>
              <v-expansion-panels focusable multiple v-model="refPanelsOpenedByDefault">
                <!-- Images panel -->
                <v-expansion-panel key="panel-images" v-if="images && images.length">
                  <v-expansion-panel-header color="blue-grey lighten-5">
                    <h5 class="card-title card-title-mediatype text-center">Images</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="container-fluid no-padding-sides container-media">
                      <div class="row justify-content-center row-media">
                        <div class="col-12 col-sm-10 col-md-6 col-xl-2" v-for="image in images" :key="image.id">
                          <div class="card shadow-sm card-media" :class="image.isActive ? 'active' : 'not-active'" v-on:click="onCardMediaClicked(image)">
                            <img class="card-img-top img-fluid" :src="image.src" :alt="image.alt" />
                            <div class="card-body p-auto">
                              <h5 class="card-title text-center my-auto">{{ image.alt }}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Videos panel -->
                <v-expansion-panel key="panel-videos" v-if="videos && videos.length">
                  <v-expansion-panel-header color="blue-grey lighten-5">
                    <h5 class="card-title card-title-mediatype text-center">Vidéos</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="container-fluid no-padding-sides container-media">
                      <div class="row justify-content-center row-media">
                        <div class="col-12 col-sm-10 col-md-6 col-xl-2" v-for="video in videos" :key="video.id">
                          <div class="card shadow-sm card-media" :class="video.isActive ? 'active' : 'not-active'" v-on:click="onCardMediaClicked(video)">
                            <img class="card-img-top img-fluid" :src="video.src" :alt="video.alt" />
                            <div class="card-body p-auto">
                              <h5 class="card-title text-center my-auto">{{ video.alt }}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Urls panel -->
                <v-expansion-panel key="panel-urls" v-if="urls && urls.length">
                  <v-expansion-panel-header color="blue-grey lighten-5">
                    <h5 class="card-title card-title-mediatype text-center">Urls</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="container-fluid no-padding-sides container-media">
                      <div class="row justify-content-center row-media">
                        <div class="col-12 col-sm-10 col-md-6 col-xl-2" v-for="url in urls" :key="url.id">
                          <div class="card shadow-sm card-media" :class="url.isActive ? 'active' : 'not-active'" v-on:click="onCardMediaClicked(url)">
                            <img class="card-img-top img-fluid" :src="url.src" :alt="url.alt" />
                            <div class="card-body p-auto">
                              <h5 class="card-title text-center my-auto">{{ url.alt }}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!-- Others panel -->
                <v-expansion-panel key="panel-others" v-if="others && others.length">
                  <v-expansion-panel-header color="blue-grey lighten-5">
                    <h5 class="card-title card-title-mediatype text-center">Autres</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="container-fluid no-padding-sides container-media">
                      <div class="row justify-content-center row-media">
                        <div class="col-12 col-sm-10 col-md-6 col-xl-2" v-for="other in others" :key="other.id">
                          <div class="card shadow-sm card-media" :class="other.isActive ? 'active' : 'not-active'" v-on:click="onCardMediaClicked(other)">
                            <img class="card-img-top img-fluid" :src="other.src" :alt="other.alt" />
                            <div class="card-body p-auto">
                              <h5 class="card-title text-center my-auto">{{ other.alt }}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
      </div>
      <!-- Manage medias -->
      <div class="col-12 col-lg-4 col-xl-3">
        <div class="container-fluid sticky-top">
          <!-- Top Info Label -->
          <div class="row">
            <div class="col-12 no-padding-sides">
              <!-- Add media -->
              <div class="card" v-if="!currentlySelectedMedia">
                <div class="card-body p-auto">
                  <h4 class="card-title text-center my-auto">Importer des médias</h4>
                </div>
                <div class="card-body p-auto">
                  <!-- Add images -->
                  <div v-if="!addMediaFormModel.url && !addMediaFormModel.name">
                    <v-form ref="createMediasForm">
                      <v-file-input
                        :prepend-icon="icon"
                        :rules="filesInputRules"
                        v-model="addMediaFormModel.images"
                        counter
                        outlined
                        chips
                        show-size
                        multiple
                        label="Ajouter des fichiers"
                        accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.xls,.xlsx,.pdf,image/*,video/*"
                      ></v-file-input>
                    </v-form>
                  </div>

                  <!-- Display divider if display both input types -->
                  <v-divider v-if="!addMediaFormModel.url && !addMediaFormModel.name && (!addMediaFormModel.images || addMediaFormModel.images.length === 0)"></v-divider>

                  <!-- Add Urls -->
                  <div v-if="!addMediaFormModel.images || addMediaFormModel.images.length === 0">
                    <v-form ref="createMediasFormUrl">
                      <!-- Url Title -->
                      <v-text-field
                        :prepend-icon="mdiLabel"
                        v-model="addMediaFormModel.name"
                        clearable
                        outlined
                        label="Titre du lien"
                        :rules="urlTitleRules"
                      ></v-text-field>
                      <!-- Url value -->
                      <v-text-field :prepend-icon="linkIcon" v-model="addMediaFormModel.url" clearable outlined label="Ajouter un lien" :rules="urlRules"></v-text-field>
                    </v-form>
                  </div>

                  <!-- Add medias submit button -->
                  <div class="card-body d-flex justify-content-end" style="padding: 1px">
                    <v-btn @click="submitMediasForm" :disabled="shouldSubmitMediasButtonBeDisabled()">Importer</v-btn>
                  </div>
                </div>
              </div>
              <!-- Edit currently selected media -->
              <div class="card" style="max-height: 100%" v-else>
                <!-- <pre>{{ currentlySelectedMedia }}</pre> -->
                <!-- Card illustration -->
                <div style="max-height: 60%; max-width: 500px">
                  <!-- Action buttons -->
                  <div class="media-action-buttons-container">
                    <!-- Unselect media button -->
                    <v-btn class="media-action-button" @click="unselectMedia" fab x-small dark color="grey">
                      <v-icon dark> mdi-close </v-icon>
                    </v-btn>

                    <!-- Edit media button -->
                    <v-btn v-if="!isEditingMedia" class="media-action-button" fab dark x-small color="orange" v-on:click="onEditMediaClicked(currentlySelectedMedia)">
                      <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>

                    <!-- Delete media button -->
                    <v-btn class="media-action-button" fab dark x-small color="red" v-on:click="deleteMedia(currentlySelectedMedia)">
                      <v-icon dark>mdi-delete</v-icon>
                    </v-btn>
                  </div>

                  <!-- if it is an image -->
                  <v-img v-if="currentlySelectedMedia.mediaType == 1" :src="currentlySelectedMedia.src" :alt="currentlySelectedMedia.alt"></v-img>
                  <!-- else if it is a video -->
                  <video-player
                    v-else-if="
                      (currentlySelectedMedia.mediaType == 2 || currentlySelectedMedia.mediaType == 4) &&
                      (currentlySelectedMedia.videoOptions || currentlySelectedMedia.youtube)
                    "
                    :options="currentlySelectedMedia.videoOptions"
                    :key="currentlySelectedMedia.id"
                    style="max-height: 100%; width: auto"
                  ></video-player>
                  <!-- else if it is a video from canal sport -->
                  <div v-else-if="currentlySelectedMedia.mediaType == 4 && currentlySelectedMedia.canal" style="max-height: 100%; width: auto">
                    <iframe :src="currentlySelectedMedia.url" style="width: 100%; height: 100%"></iframe>
                  </div>
                  <!-- else if it is an url with no preview -->
                  <a v-else-if="currentlySelectedMedia.mediaType == 4" :href="currentlySelectedMedia.url" target="_blank">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-img :src="currentlySelectedMedia.src" :alt="currentlySelectedMedia.alt" style="max-height: 100%; width: auto" v-bind="attrs" v-on="on"></v-img>
                      </template>
                      <span>Accéder à l'url</span>
                    </v-tooltip>
                  </a>
                </div>
                <!-- title read -->
                <div v-if="!isEditingMedia" class="card-body p-auto" style="max-height: 40%">
                  <h4 class="card-title text-center my-auto">{{ currentlySelectedMedia.alt }}</h4>
                </div>
                <!-- title edit -->
                <div v-else class="card-body p-auto" style="max-height: 40%">
                  <v-form ref="editMediaForm">
                    <v-text-field :prepend-icon="mdiLabel" v-model="currentlySelectedMedia.alt" outlined label="Titre" :rules="urlTitleRules"></v-text-field>
                  </v-form>
                  <!-- Save media button -->
                  <v-btn class="mx-2 float-right" color="blue darken-1" text v-on:click="editMediaTitle(currentlySelectedMedia)"> ENREGISTRER </v-btn>

                  <!-- Cancel editing button -->
                  <v-btn class="mx-2 float-right" color="blue darken-1" text v-on:click="cancelEditMediaMode()"> ANNULER </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mdiImage, mdiLinkVariant, mdiLabel } from "@mdi/js";
import { getAllMediasForCurrentUserAsync, createMediaAsync, getDownloadMediaByPathAsync, updateMediaAsync, deleteMediaAsync } from "../../api/mediaApi";
import { VCard, VSelect } from "vuetify/lib";
import VideoPlayer from "../VideoPlayer";
import store from "@/store";
import { MediaType } from "@/models/enums";
import PermissionsService from "@/services/PermissionsService";

export default {
  components: {
    VCard,
    VSelect,
    VideoPlayer,
  },

  data() {
    return {
      refPanelsOpenedByDefault: [0, 1, 2],
      _medias: [],
      images: [],
      videos: [],
      others: [],
      urls: [],
      options: [{ name: "Supprimer cet élément", action: "delete" }],
      currentlySelectedMedia: null,
      addMediaFormModel: {},
      filesInputRules: [(files) => !!files || "Requis.", (files) => !files || !files.some((file) => file.size > 524288000) || "Max 500 Mo"],
      urlTitleRules: [(value) => !!value || "Requis.", (value) => (value && value.length <= 25) || "Max 25 caractères"],
      urlRules: [(value) => !!value || "Requis.", (value) => this.isURL(value) || "L'url n'est pas valide"],
      isEditingMedia: false,
      mediaTitleBeforeEditing: "",
      icon: mdiImage,
      linkIcon: mdiLinkVariant,
      mdiLabel: mdiLabel,
    };
  },

  computed: {
    canViewOwnMedias() {
      return PermissionsService.MediasPermissionsService.canViewOwnMedias;
    },
    canViewAllMedias() {
      return PermissionsService.MediasPermissionsService.canViewAllMedias;
    },
  },

  async mounted() {
    // Check if the user can see this page
    if (!this.canViewOwnMedias && !this.canViewAllMedias) {
      store.dispatch("setSnackbar", {
        title: `Non Autorisé`,
        text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
        status: "warning",
        timeout: 2000,
      });

      this.$router.replace("/");
    }

    // Load and init all medias
    await this.loadAndInitAllMedias();
  },

  methods: {
    // Load and init all medias
    async loadAndInitAllMedias() {
      // Get all medias from backend for current user
      await this.loadAllMedias();
      // Initiate all media types
      await this.initAllMedias();
    },

    // Initiate all media types
    async initAllMedias() {
      // Initiate the images from medias
      this.initImages();
      // Initiate the videos from medias
      this.initVideos();
      // Initiate the urls from medias
      this.initUrls();
      // Initiate the others from medias
      this.initOthers();
    },

    // Initiate the images from medias
    initImages() {
      this.images = this._medias.filter((media) => media.mediaType == MediaType.IMAGE);
    },

    // Initiate the videos from medias
    initVideos() {
      this.videos = this._medias.filter((media) => media.mediaType == MediaType.VIDEO);
    },

    // Initiate the urls from medias
    initUrls() {
      this.urls = this._medias.filter((media) => media.mediaType == MediaType.URL);
    },

    // Initiate the others from medias
    initOthers() {
      this.others = this._medias.filter((media) => media.mediaType == MediaType.OTHER);
    },

    // Get all medias from backend for current user
    async loadAllMedias() {
      // Increment the request counter for the loader
      store.dispatch("addRemoveRequest", true);

      let list = await getAllMediasForCurrentUserAsync();
      const toReturn = [];
      for (let i = 0; i < list.length; i++) {
        let url = list[i].url;
        if (url) {
          const urlCreator = window.URL || window.webkitURL;
          let response;
          let result;
          switch (list[i].typeId) {
            case 1:
              response = await getDownloadMediaByPathAsync(url);
              if(!response) break;
              result = await response.blob();
              list[i].src = urlCreator.createObjectURL(result);
              toReturn.push({
                id: list[i].id,
                src: urlCreator.createObjectURL(result),
                alt: list[i].name,
                mediaType: list[i].mediaType,
              });
              break;
            case 2:
              response = await getDownloadMediaByPathAsync(url);
              if(!response) break;
              result = await response.blob();
              list[i].image = require("@/assets/Placeholder_video.jpg");
              list[i].videoOptions = {
                techOrder: ["html5", "youtube"],
                autoplay: false,
                controls: true,
                responsive: true,
                sources: [
                  {
                    src: urlCreator.createObjectURL(result),
                    type: response.headers.get("Content-Type"),
                  },
                ],
              };
              toReturn.push({
                id: list[i].id,
                src: require("@/assets/Placeholder_video.jpg"),
                alt: list[i].name,
                mediaType: list[i].mediaType,
                videoOptions: list[i].videoOptions,
                image: list[i].image,
              });

              break;
            case 3:
              response = await getDownloadMediaByPathAsync(url);
              if(!response) break;
              result = await response.blob();
              list[i].image = require("@/assets/Placeholder_fichier.jpg");
              list[i].file = urlCreator.createObjectURL(result);
              toReturn.push({
                id: list[i].id,
                src: require("@/assets/Placeholder_fichier.jpg"),
                alt: list[i].name,
                mediaType: list[i].mediaType,
                file: list[i].file,
                image: list[i].image,
              });
              break;
            case 4:
              list[i].image = require("@/assets/Placeholder_lien.jpg");
              const parse = require("url-parse");
              const parsed = parse(url, true);
              const youtubeRegex = /http(?:s?):\/\/(?:www\.)?youtu(?:be\.com\/watch\?v=|\.be\/)([\w\-\_]*)(&(amp;)?‌​[\w\?‌​=]*)?/gim;
              const pictureRegex = /http[s]?:\/\/.+\.(jpeg|png|jpg|gif)/gim;
              list[i].src = url;
              if (parsed.hostname.includes("canal-sport") && parsed.pathname.endsWith("player")) list[i].canal = true;
              else if (youtubeRegex.exec(url)) {
                list[i].youtube = true;
                list[i].videoOptions = {
                  techOrder: ["html5", "youtube"],
                  autoplay: false,
                  controls: true,
                  responsive: true,
                  sources: [
                    {
                      src: url,
                      type: "video/youtube",
                    },
                  ],
                };
              } else if (pictureRegex.exec(url)) {
                list[i].isImage = true;
                list[i].image = url;
              }

              toReturn.push({
                id: list[i].id,
                src: require("@/assets/Placeholder_lien.jpg"),
                alt: list[i].name,
                mediaType: list[i].mediaType,
                videoOptions: list[i].videoOptions,
                image: list[i].image,
                youtube: list[i].youtube,
                isImage: list[i].isImage,
                canal: list[i].canal,
                url: list[i].url,
              });
              break;
            default:
              break;
          }
        }
      }

      this._medias = _.cloneDeep(toReturn);

      // Decrement the request counter for the loader
      store.dispatch("addRemoveRequest", false);
    },

    // Event on Add Media clicked, submit the form to create a new media
    async submitMediasForm() {
      // Validate the inner form
      var isFilesFormValid = this.$refs.createMediasForm ? this.$refs.createMediasForm.validate() : false;
      var isUrlFormValid = this.$refs.createMediasFormUrl ? this.$refs.createMediasFormUrl.validate() : false;

      // if the form is valid
      if ((this.addMediaFormModel.images && isFilesFormValid) || isUrlFormValid) {
        const formData = new FormData();

        if (!this.addMediaFormModel) return;

        // If image
        if (this.addMediaFormModel.images) {
          Array.from(Array(this.addMediaFormModel.images.length).keys()).map((x) => {
            formData.append("files", this.addMediaFormModel.images[x], this.addMediaFormModel.images[x].name);
          });
        }

        // If Url
        if (this.addMediaFormModel.url) {
          formData.append("name", this.addMediaFormModel.name);
          formData.append("url", this.addMediaFormModel.url);
        }

        var result = await createMediaAsync(formData);
        if (result && result.id > 0) {
          store.dispatch("setSnackbar", {
            title: "Media créé",
            text: `Le media a bien été créé.`,
            status: "success",
            timeout: 2000,
          });

          // Empty the creation form
          this.addMediaFormModel = {};

          // reset the form validation
          if (this.$refs.createMediasForm) {
            this.$refs.createMediasForm.reset();
          }
          if (this.$refs.createMediasFormUrl) {
            this.$refs.createMediasFormUrl.reset();
          }

          // Load and init all medias
          await this.loadAndInitAllMedias();
        }
      }
      // Else display all the errors
      else {
        // Handle missing url title
        if (!this.addMediaFormModel.images && (!this.addMediaFormModel.name || this.addMediaFormModel.name.length < 1)) {
          store.dispatch("setSnackbar", {
            title: "Titre du lien requis",
            text: "Veuillez renseigner le titre du lien.",
            status: "error",
            timeout: 2000,
          });
        }
        // Handle missing url value
        if (!this.addMediaFormModel.images && (!this.addMediaFormModel.url || this.addMediaFormModel.url.length < 1)) {
          store.dispatch("setSnackbar", {
            title: "Lien requis",
            text: "Veuillez renseigner le lien.",
            status: "error",
            timeout: 2000,
          });
        }
        // Handle wrong url value
        if (!this.addMediaFormModel.images && this.addMediaFormModel.url && !this.isURL(this.addMediaFormModel.url)) {
          store.dispatch("setSnackbar", {
            title: "Lien non valide",
            text: "Veuillez renseigner un lien valide.",
            status: "error",
            timeout: 2000,
          });
        }
      }
    },

    // Delete the selected media
    async deleteMedia(media) {
      if (confirm(`Etes-vous sûr de vouloir supprimer ${media.alt} ?`)) {
        var result = await deleteMediaAsync(media.id);

        if (result && result.id > 0) {
          store.dispatch("setSnackbar", {
            title: "Media supprimée",
            text: "Le media a bien été supprimée.",
            status: "success",
            timeout: 2000,
          });

          // Unselect media
          this.unselectMedia();

          // Load and init all medias
          await this.loadAndInitAllMedias();
        }
      }
    },

    // Event on media card clicked
    async onCardMediaClicked(mediaParam) {
      let indexMedia = this._medias.findIndex((media) => media.id === mediaParam.id);

      if (this._medias[indexMedia]) {
        // If we just clicked on already selected media, we wanna unselect it
        if (this.currentlySelectedMedia && mediaParam.id === this.currentlySelectedMedia.id) {
          // cancel edit media mode
          this.cancelEditMediaMode();

          this._medias[indexMedia].isActive = !this._medias[indexMedia].isActive;
          this.currentlySelectedMedia = null;
        }
        // Else we wanna unselect currently selected media and select the new one
        else {
          // remove active class on each
          for (let i = 0; i < this._medias.length; i++) {
            this._medias[i].isActive = false;
          }

          // then activate new media
          this._medias[indexMedia].isActive = true;
          this.currentlySelectedMedia = mediaParam;
        }

        // Initiate all media types
        await this.initAllMedias();
      }
    },

    // unselect media
    unselectMedia() {
      // cancel edit media mode
      this.cancelEditMediaMode();

      //unselect media
      this.currentlySelectedMedia = null;
      // remove active class on each
      for (let i = 0; i < this._medias.length; i++) {
        this._medias[i].isActive = false;
      }
    },

    // On edit media button clicked
    onEditMediaClicked() {
      this.isEditingMedia = true;
      this.mediaTitleBeforeEditing = this.currentlySelectedMedia.alt;
    },

    // cancel edit media mode
    cancelEditMediaMode(needToRevertMediaName = true) {
      this.isEditingMedia = false;
      if (needToRevertMediaName) {
        this.currentlySelectedMedia.alt = this.mediaTitleBeforeEditing.length ? this.mediaTitleBeforeEditing : this.currentlySelectedMedia.alt;
      }
      this.mediaTitleBeforeEditing = "";
    },

    // Edit media title
    async editMediaTitle(mediaParam) {
      var isFormValid = this.$refs.editMediaForm.validate();
      // If the form is valid
      if (isFormValid) {
        let indexMedia = this._medias.findIndex((media) => media.id === mediaParam.id);
        let mediaToUpdate = this._medias[indexMedia];
        mediaToUpdate.name = mediaParam.alt;

        var result = await updateMediaAsync(mediaToUpdate);

        if (result && result.id > 0) {
          store.dispatch("setSnackbar", {
            title: `Media mis à jour`,
            text: `Le media a bien été mis à jour.`,
            status: "success",
            timeout: 2000,
          });

          // Load and init all medias
          await this.loadAndInitAllMedias();
          // cancel edit media mode
          this.cancelEditMediaMode(false);
        }
      }
      // else the form is not valid
      else {
        // Handle missing media title
        if (!mediaParam.alt || mediaParam.alt.length < 1) {
          store.dispatch("setSnackbar", {
            title: "Titre du média requis",
            text: "Veuillez renseigner le titre du média.",
            status: "error",
            timeout: 2000,
          });
        }
        // Handle media title too long
        if (mediaParam.alt && mediaParam.alt.length > 25) {
          store.dispatch("setSnackbar", {
            title: "Titre du média trop long",
            text: "Le titre du média ne peut dépasser 25 caractères.",
            status: "error",
            timeout: 2000,
          });
        }
      }
    },

    // Check if string is url with regex
    isURL(str) {
      var expression =
        "^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$";
      var regex = new RegExp(expression);

      if (str && str.match(regex)) {
        return true;
      } else {
        return false;
      }
    },

    // Check if the submit new medias button should be disabled
    shouldSubmitMediasButtonBeDisabled() {
      if (!this.addMediaFormModel) {
        return true;
      } else {
        if (!this.addMediaFormModel.images || this.addMediaFormModel.images.length === 0) {
          if ((!this.addMediaFormModel.url || this.addMediaFormModel.url.length < 1) && (!this.addMediaFormModel.name || this.addMediaFormModel.name.length < 1)) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
// .draggable {
//   max-width: 50px;
//   max-height: 50px;
// }

// #images {
//   display: inline !important;
//   max-width: 100px;

//   padding: 3px;
// }
// .media {
//   max-height: 60px;
// }
// .card-text {
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }
// #images .img_dragging {
//   opacity: 0.4;
// }
// .mx-auto {
//   min-width: 400px;
// }

// label {
//   border: 1px solid #fff;

//   display: block;
//   position: relative;

//   cursor: pointer;
// }

// label:before {
//   background-color: white;
//   color: white;
//   content: " ";
//   display: block;
//   border-radius: 50%;
//   border: 1px solid grey;
//   position: absolute;
//   top: -5px;
//   left: -5px;
//   width: 25px;
//   height: 25px;
//   text-align: center;
//   line-height: 28px;
//   transition-duration: 0.4s;
//   transform: scale(0);
// }

// label img {
//   transition-duration: 0.2s;
//   transform-origin: 50% 50%;
// }
// .list {
//   padding-right: 8px;
// }
</style>

<style lang="scss" scoped>
.v-expansion-panel-header {
  padding-top: 0;
  padding-bottom: 0;
}
.card-title-mediatype {
  font-weight: 800 !important;
}
.container-media {
  display: flex;
  padding-top: 1vh;
}
.row-media {
  width: 100%;
  height: 100%;
}
.card-media {
  display: block;
  height: 100%;
  cursor: pointer;
}
.card-img-top {
  display: block;
  margin-left: auto;
  margin-right: auto;
  max-height: 120px;
  width: auto;
}
.active {
  border: 1px solid #0071c5;
  background-color: #0071c5;
  color: white;
  //   box-shadow: 0 .125rem .25rem rgba(0, 112, 197, 0.412) !important;
}
.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}
.media-action-buttons-container {
  position: absolute;
  z-index: 2;
  top: 0.5vh;
  right: 0.5vh;
  display: flex;
  flex-direction: column;
}
.media-action-button {
  margin-bottom: 0.5vh;
}
</style>
